//
//
//
//
//
//
//
//
//
//
//
//
//
//

import XNumber from '../x-number'

export default {
  name: 'inline-x-number',
  extends: XNumber
}
